<template>
  <div class="wrapper">
    <parallax
      class="page-header header-filter clear-filter"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 md-xlarge-size-80 mx-auto text-center"
          >
            <h1 class="title">
              Find the right Engineer
            </h1>
            <h4>
              Search our database of registered professional ASEAN Engineers to find the help you need
            </h4>
          </div>
          <div class="md-layout-item md-size-66 md-small-100 mx-auto">
            <md-card class="md-card-form-horizontal">
              <md-card-content>
                <form
                  v-on:submit="gotoFindEngineer"
                >
                  <div class="md-layout">
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <md-field>
                        <md-select
                            id="field"
                            v-model="field"
                            name="field"
                            @md-selected="changePlaceholderText"
                        >
                          <md-option value="aer_id">
                              AER ID
                          </md-option>
                          <md-option value="name">
                              Name
                          </md-option>
                        </md-select>
                    </md-field>
                    </div>
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <md-field>
                        <md-input
                          v-model="searchValue"
                          :placeholder="placeholderText"
                        />
                      </md-field>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100">
                      <md-button
                        class="md-primary md-block"
                        @click.prevent="gotoFindEngineer"
                      >
                        Search
                      </md-button>
                    </div>
                  </div>
                </form>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>
    </parallax>
    <div
      id="main-panel"
      class="main main-raised"
    >
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">
                Benefits of joining AER
              </h2>
            </div>
          </div>
          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-warning">
                    <md-icon>verified</md-icon>
                  </div>
                  <h4 class="info-title">
                    Verification
                  </h4>
                  <p>
                    Your identity and profile is publicly searchable and verified by our organisations.
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-success">
                    <md-icon>attach_money</md-icon>
                  </div>
                  <h4 class="info-title">
                    Better Employment Prospects
                  </h4>
                  <p>
                    Your specialisations and experience is easily found by prospects in ASEAN countries; giving you the exposure.
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-primary">
                    <md-icon>public</md-icon>
                  </div>
                  <h4 class="info-title">
                    Wider Networking &amp; strategic alliances
                  </h4>
                  <p>
                    Easily find like-minded engineers to collaborate on research, business or knowledge sharing. 
                  </p>
                </div>
              </div>
            </div>
            <div class="md-layout">
              <div
                class="md-layout-item md-small-size-100 mx-auto text-center"
              >
              <router-link :to="{name: 'join'}">
                <md-button class="md-primary">
                  I am interested to join
                </md-button>
              </router-link>
                <br /><br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";

export default {
    name: "Index",
    components: {
    },
    mixins: [Mixins.HeaderImage],
    bodyClass: "index-page",
    props: {
        image: {
            type: String,
            default: require("@/assets/img/hero2.jpg")
        },
        profile: {
            type: String,
            default: require("@/assets/img/profile.jpg")
        }
    },
    data() {
        return {
            searchValue: null,
            placeholderText: 'Enter AER ID',
            field: "aer_id"
        };
    },
    created() {
      
    },
    methods: {
        leafActive() {
            if (window.innerWidth < 768) {
                this.leafShow = false;
            } else {
                this.leafShow = true;
            }
        },
        changePlaceholderText(field) {
          switch(field) {
            case 'aer_id':
              this.placeholderText = "Enter AER ID";
              break;
            case 'mheo_id':
              this.placeholderText = "Enter Member Organization ID";
              break;
            case 'name':
              this.placeholderText = "Enter Engineer Name";
              break;
            case 'specialization':
              this.placeholderText = "Enter Specialization";
              break;
            default:
          }
        },
        gotoFindEngineer() {
          this.$router.push({name: "find-engineer", query: {
            searchValue: this.searchValue,
            field: this.field
          }});
        }
    }
};
</script>